/* Schnellkauf: laedt die Section quick-add eines Produkts in den Drawer, geoeffnet ueber [data-quick-add="handle"]. Wechsel auf ein anderes Listing der Familie laedt die Section nach statt die Seite zu wechseln. */

const root = () => window.Shopify?.routes?.root || '/';

class KgQuickAdd extends HTMLElement {
  connectedCallback() {
    /* Nur ein Schnellkauf-Drawer je Seite: die Instanz mit data-primary (Produktseite, erbt deren Darstellung) gewinnt */
    const others = [...document.querySelectorAll('kg-quick-add')].filter((el) => el !== this);
    if (others.length && !this.hasAttribute('data-primary')) {
      this.remove();
      return;
    }
    others.filter((el) => !el.hasAttribute('data-primary')).forEach((el) => el.remove());
    this.dialog = this.querySelector('kg-dialog');
    this.body = this.querySelector('[data-quick-add-body]');
    this.titleElement = this.querySelector('.drawer__title');
    this.defaultTitle = this.titleElement?.textContent;
    this.loading = this.querySelector('[data-quick-add-loading]')?.cloneNode(true);
    this.onClick = (event) => {
      const trigger = event.target.closest('[data-quick-add]');
      if (!trigger) return;
      event.preventDefault();
      this.open(trigger.dataset.quickAdd, trigger);
    };
    document.addEventListener('click', this.onClick);
    this.addEventListener('product:added', async (event) => {
      const edit = this.edit;
      this.edit = null;
      this.classList.remove('is-edit');
      this.giftEdit = this.gift;
      if (edit) await this.finishEdit(edit, event.detail?.item);
      const cartDrawer = document.querySelector('kg-cart[data-open-on-add]');
      window.setTimeout(() => this.dialog?.close(), cartDrawer ? 250 : 1200);
    });
    /* Nach einem Variantenwechsel wird der Kaufen-Button neu gerendert, Beschriftung im Bearbeiten-Modus erneut setzen */
    this.addEventListener('variant:change', () => this.applyEditLabel(), true);
    /*
      Der Wechsel im Drawer geht die Seite dahinter nichts an: sonst stellt sich
      dort zum Beispiel die Galerie um und scrollt den Besucher aus dem Bereich.
    */
    this.addEventListener('variant:change', (event) => event.stopPropagation());
    /*
      Auswahlmodus aus dem Bundle: nicht kaufen, sondern die gewaehlte Variante
      an die Kachel zurueckmelden. Laeuft in der Erfassungsphase, damit das
      Produktformular gar nicht erst absendet.
    */
    this.addEventListener('submit', (event) => {
      if (!this.pick || !event.target.matches('form')) return;
      const id = event.target.querySelector('[name="id"]')?.value;
      const handle = this.currentHandle;
      if (!id || !handle) return;
      event.preventDefault();
      event.stopPropagation();
      document.dispatchEvent(new CustomEvent('bundle:pick', {
        bubbles: true,
        detail: { tile: this.pick, variant: Number(id), handle },
      }));
      this.dialog?.close();
    }, true);
    /* Vor dem Absenden im Geschenkmodus die Kennzeichnung als Geschenk mitschicken */
    this.addEventListener('submit', (event) => {
      if (!this.gift || !event.target.matches('form')) return;
      if (event.target.querySelector('input[name="properties[_kgroup_gift]"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_kgroup_gift]';
      input.value = '1';
      event.target.append(input);
    }, true);
    /*
      Nur der eigene Schuber zaehlt. Das Ereignis steigt auf, und im Drawer liegen weitere
      Schuber: die Sortenauswahl und die Bundle-Schrittfolge. Schloss sich einer davon, galt
      das Bearbeiten als beendet — wer ein Bundle aus dem Warenkorb heraus aenderte, legte es
      danach ein zweites Mal hinein, statt die alte Zeile zu ersetzen.
    */
    this.dialog?.addEventListener('dialog:close', (event) => {
      if (event.target !== this.dialog) return;
      this.pick = null;
      this.gift = false;
      this.classList.remove('is-gift');
      this.edit = null;
      this.classList.remove('is-edit');
      if (this.titleElement && this.defaultTitle) this.titleElement.textContent = this.defaultTitle;
    });
    /* Linker-Funktion im Sheet: Ziel-Listing hier laden, product-form.js bricht dann die Seitennavigation ab. */
    this.addEventListener('product:navigate', (event) => {
      event.preventDefault();
      this.load(event.detail.url);
    });
  }

  disconnectedCallback() {
    if (this.onClick) document.removeEventListener('click', this.onClick);
  }

  /*
    Bearbeiten aus dem Warenkorb: der Ausloeser bringt Variante, Zeilenschluessel
    und Menge mit. Die gewaehlte Variante ist vorausgewaehlt, nach dem Kaufen
    ersetzt die neue Zeile die alte (finishEdit).
  */
  open(handle, trigger) {
    if (!handle || !this.dialog || !this.body) return;
    const data = trigger?.dataset || {};
    this.edit = data.quickAddReplace ? { key: data.quickAddReplace, quantity: Number(data.quickAddQuantity) || 1 } : null;
    /* Auswahlmodus: die Kachel, die das Ergebnis erwartet */
    this.pick = data.quickAddPick || null;
    this.currentHandle = handle;
    /* Geschenk: nur die Sorten des Geschenkprodukts, keine Groessen und keine verlinkten Listings, Zeile bleibt als Geschenk markiert */
    this.gift = data.quickAddGift === '1';
    this.classList.toggle('is-gift', this.gift);
    /* Wie `is-gift`: Der Modus steht am Element, damit CSS ihn kennt. */
    this.classList.toggle('is-edit', Boolean(this.edit));
    let title = this.defaultTitle;
    if (this.gift && this.dataset.giftTitle) title = this.dataset.giftTitle;
    else if (this.edit && this.dataset.editTitle) title = this.dataset.editTitle;
    else if (this.pick && this.dataset.pickTitle) title = this.dataset.pickTitle;
    if (this.titleElement) this.titleElement.textContent = title;
    this.body.replaceChildren(this.loading ? this.loading.cloneNode(true) : '');
    this.dialog.open(trigger);
    const url = new URL(`${root()}products/${encodeURIComponent(handle)}`, window.location.origin);
    if (data.quickAddVariant) url.searchParams.set('variant', data.quickAddVariant);
    this.load(url.toString());
  }

  /* Geschenkmodus: nur die erste Option (Sorte) sichtbar, weitere Optionen bleiben versteckt im Formular (fuer die Variantenwahl), verlinkte Werte und Preis raus */
  restrictToGift(content) {
    const groups = [...content.querySelectorAll('.product-option')];
    groups.slice(1).forEach((group) => {
      group.hidden = true;
    });
    content.querySelectorAll('[data-linked-url]').forEach((node) => node.remove());
    content.querySelectorAll('[data-price]').forEach((node) => node.remove());
  }

  applyEditLabel() {
    const label = this.pick ? this.dataset.pickLabel : this.edit ? this.dataset.updateLabel : null;
    if (!label) return;
    const button = this.body?.querySelector('[data-add-to-cart]');
    if (button && !button.disabled) button.textContent = label;
  }

  /* Alte Zeile durch die neue ersetzen, Menge uebernehmen; gleiche Variante: nur die Menge zuruecksetzen */
  async finishEdit(edit, item) {
    const change = (id, quantity) => fetch(`${root()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });
    try {
      const key = item?.key;
      if (this.giftEdit) {
        /* Geschenk: genau eine Geschenkzeile mit Menge 1 behalten, naemlich die neue */
        const current = await (await fetch(`${root()}cart.js`)).json();
        const gifts = current.items.filter((line) => line.properties?._kgroup_gift);
        for (const line of gifts) {
          if (line.key === key) {
            if (line.quantity !== 1) await change(line.key, 1);
          } else {
            await change(line.key, 0);
          }
        }
        this.giftEdit = false;
      } else {
        /*
          Der Schuber legt immer genau ein Stueck hinzu. Die Zeile, auf der der Kunde
          landet, soll danach die Menge der alten Zeile tragen — also ihren Stand von
          vor dem Hinzufuegen plus die alte Menge.

          Entscheidend ist, ob das Stueck auf derselben Zeile gelandet ist: Hat der Kunde
          nichts geaendert, steckt die alte Menge in `item.quantity` schon drin, und sie
          noch einmal dazuzurechnen verdoppelte die Zeile. Bei einer anderen Variante ist
          es eine andere Zeile, und die alte Menge muss wirklich dazu.
        */
        const selbeZeile = key === edit.key;
        const vorherigerStand = (item?.quantity || 1) - 1;
        const target = Math.max(1, selbeZeile ? vorherigerStand : vorherigerStand + edit.quantity);
        if (key && target !== item.quantity) await change(key, target);
        if (!selbeZeile) await change(edit.key, 0);
      }
      const cart = await (await fetch(`${root()}cart.js`)).json();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, source: 'quick-add' } }));
    } catch {
      /* Warenkorb bleibt wie vom Hinzufuegen */
    }
  }

  async load(url) {
    const target = new URL(url, window.location.origin);
    const parts = target.pathname.split('/products/');
    if (parts[1]) this.currentHandle = parts[1].split(/[/?#]/)[0];
    target.searchParams.set('section_id', 'quick-add');
    const request = (this.requestId = (this.requestId || 0) + 1);
    this.body.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(target.toString());
      if (!response.ok) throw new Error(`Quick add ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('.shopify-section') || doc.body;
      if (request !== this.requestId) return;
      if (this.gift) this.restrictToGift(content);
      this.body.replaceChildren(...content.childNodes);
      this.body.scrollTop = 0;
      /* Auswahlmodus: das Formular im Drawer laesst Adresse und Galerie der Seite in Ruhe */
      if (this.pick) {
        this.body.querySelectorAll('kg-product-form').forEach((form) => form.setAttribute('data-detached', ''));
      }
      this.applyEditLabel();
    } catch {
      target.searchParams.delete('section_id');
      window.location.href = target.toString();
    } finally {
      this.body.removeAttribute('aria-busy');
    }
  }
}

customElements.define('kg-quick-add', KgQuickAdd);
